import { useMutation, useQuery } from '@tanstack/react-query';

import { ApiClient } from '../api/apiClient';
import { PlanSponsorAuditSummary } from '../models/api/PlanSponsorAuditSummary';
import { UpdateDistributionDetailsRequest } from '../models/api/UpdateDistributionDetailsRequest';

export function useGetAudits(dataSourceAudit: string, token: string, aud: string) {
  const isEnabled = Boolean(token) && Boolean(aud);

  return useQuery<PlanSponsorAuditSummary[]>({
    queryKey: ['audits', { dataSourceAudit: dataSourceAudit, token, aud }],
    enabled: isEnabled,
    queryFn: () => {
      const segments = [] as string[];
      if (dataSourceAudit) {
        segments.push(dataSourceAudit);
      }
      segments.push(`token=${encodeURIComponent(token)}`);
      segments.push(`aud=${encodeURIComponent(aud)}`);
      const queryString = segments.join('&');

      return ApiClient.get(`Audit?${queryString}`).then((response) => {
        return response.data;
      });
    },
  });
}

export function useGetAuditCount(dataSourceAudit: string, token: string, aud: string) {
  const isEnabled = Boolean(token) && Boolean(aud);

  return useQuery<number>({
    queryKey: ['auditCount', { dataSourceAudit: dataSourceAudit, token, aud }],
    enabled: isEnabled,
    queryFn: () => {
      const segments = [] as string[];
      if (dataSourceAudit) {
        segments.push(dataSourceAudit);
      }
      segments.push(`token=${encodeURIComponent(token)}`);
      segments.push(`aud=${encodeURIComponent(aud)}`);
      const queryString = segments.join('&');

      return ApiClient.get(`Audit/Count?${queryString}`).then((response) => {
        return response.data;
      });
    },
  });
}

export function useUpdateDistributionDetails() {
  return useMutation<unknown, Error, UpdateDistributionDetailsRequest>({
    mutationFn: (data: UpdateDistributionDetailsRequest) => {
      const {
        auditIds,
        subscriberDistributionDate,
        distributionMethod,
        otherMethod,
        token,
        aud,
      } = data;
      return ApiClient.post('Audit/UpdateDistributionDetails', {
        auditIds,
        subscriberDistributionDate,
        distributionMethod,
        otherMethod,
        token,
        aud,
      }).then((response) => response.data);
    },
  });
}
